<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiAccountMinus } from "@mdi/js";
export default {
  name: "MdiAccountMinus",
  data() {
    return {
      svgPath: mdiAccountMinus,
    };
  },
};
</script>
